import { render, staticRenderFns } from "./btn-tertiary.vue?vue&type=template&id=b791263a&scoped=true"
import script from "./btn-tertiary.vue?vue&type=script&lang=js"
export * from "./btn-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b791263a",
  null
  
)

export default component.exports